import topSlider from './components/topslider';
import mvSlider from './components/mvslider';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    topSlider();
    mvSlider();
  },
  false
);
